/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_1_DetailInputs */

const en_cap_full_mock_1_detail = /** @type {(inputs: Cap_Full_Mock_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gmail, CRM, Sheets`)
};

const lv_cap_full_mock_1_detail = /** @type {(inputs: Cap_Full_Mock_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gmail, CRM, Sheets`)
};

/**
* | output |
* | --- |
* | "Gmail, CRM, Sheets" |
*
* @param {Cap_Full_Mock_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_1_detail = /** @type {((inputs?: Cap_Full_Mock_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_1_detail(inputs)
	return en_cap_full_mock_1_detail(inputs)
});